import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import SVG from '@glowforge/gf-styled/components/svg';

import { GLOWFORGE_STORE } from '../../route-constants';

import { ApplyButton, ButtonWrapper } from './referral-modal.styles';

const ReferralApplyBtn = ({ setDismissed, type, icon, text, url }) => {
  const router = useRouter();

  /**
   * Run apply referral animation
   */
  const applyReferral = (e) => {
    e.preventDefault();
    setDismissed(true);
    window.scrollTo(0, 0);
    router.push(GLOWFORGE_STORE.BASE_URI);
  };

  return (
    <ButtonWrapper>
      <ApplyButton
        variant={type || 'primary'}
        /* eslint-disable-next-line react/jsx-no-bind */
        onClick={applyReferral}
        icon={icon ? <SVG id={icon.fields.id} /> : null}
        href={url}>
        {text}
      </ApplyButton>
    </ButtonWrapper>
  );
};

ReferralApplyBtn.propTypes = {
  setDismissed: PropTypes.func,
  type: PropTypes.string.isRequired,
  icon: PropTypes.shape({
    fields: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

ReferralApplyBtn.defaultProps = {
  setDismissed: () => {},
  icon: null,
};

export default ReferralApplyBtn;
